<template>
    <div class="page1">
      <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
        <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
            this.systemName
          }}
        </div>
      </div>
      <div style="width:100%;background-color: #004e96; height: 65px">
        <div
          style=" font-weight: bold;width: 1200px;margin: auto"
        >
          <navigation-bar :default-active="'资源体系'"/>
        </div>
      </div>
      <div style="width: 1200px;margin: auto;">
      <el-row  style="margin-top: 10px" v-if="all">
        <el-col >
          <el-tabs v-model="act" tabPosition="left" >
            <el-tab-pane label="标准体系" name="1">
            <el-row  style="background-color: #FFFFFF;width: 1030px;min-height: 500px">
              <el-row v-if="biaozhuntixi" style="text-align:center">
                <el-col style="margin:40px auto 0px auto " >
                  <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                </el-col>
              </el-row>
            <el-col style="width: 336px" v-for="system in pageSystem.list" :key="system.id">
              <el-card style="margin-top: 20px;margin-left: 20px">
                <div slot="header" class="clearfix" style="width: 100%">
                  <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular" type="text" @click="openDetail(system.id)">{{ system.name }}</el-button>
                </div>
                <div style="width: 100%">
                  <div class="white">
                    <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                    <template >
                      <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                    </template>
                  </div>
                  <div style="margin-top: 10px">
                    <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                    <template >
                      <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                    </template>
                  </div>
                  <div style="margin-top: 10px">
                    <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                    <template >
                      <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                      <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
            </el-tab-pane>
            <el-tab-pane label="政策体系" name="2">
              <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px">
                <el-row v-if="zhengcetixi" style="text-align:center">
                  <el-col style="margin:40px auto 0px auto " >
                    <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                  </el-col>
                </el-row>
                <el-col style="width: 336px" v-for="system in policySystem.list" :key="system.id">
                  <el-card style="margin-top: 20px;margin-left: 20px">
                    <div slot="header" class="clearfix" style="width: 100%">
                      <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular;" type="text" @click="openzhengce(system.id)">{{ system.name }}</el-button>
                    </div>
                    <div style="width: 100%">
                      <div class="white">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                        <template >
                          <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                        <template >
                          <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                        <template >
                          <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                          <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                        </template>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="机构体系" name="3">
              <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px">
                <el-row v-if="jigoutixi" style="text-align:center">
                  <el-col style="margin:40px auto 0px auto " >
                    <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                  </el-col>
                </el-row>
                <el-col style="width: 336px" v-for="system in orgSystem.list" :key="system.id">
                  <el-card  style="margin-top: 20px;margin-left: 20px">
                    <div slot="header" class="clearfix" style="width: 100%">
                      <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular;" type="text" @click="openjigou(system.id)">{{ system.name }}</el-button>
                    </div>
                    <div style="width: 100%">
                      <div class="white">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                        <template >
                          <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                        <template >
                          <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系状态：</span>
                        <template >
                          <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                          <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                        </template>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="资讯体系" name="4">
              <el-row style="background-color: #FFFFFF;width: 1030px;min-height: 500px">
                <el-row v-if="zixuntixi" style="text-align:center">
                  <el-col style="margin:40px auto 0px auto " >
                    <span style="font-size: 16px;font-family: SourceHanSansCN-Regular">暂无数据</span>
                  </el-col>
                </el-row>
                <el-col style="width: 336px" v-for="system in infoSystem.list" :key="system.id">
                  <el-card style="margin-top: 20px;margin-left: 20px">
                    <div slot="header" class="clearfix" style="width: 100%">
                      <el-button class="white" style="font-size: 16px;color: #045fb4;font-family: SourceHanSansCN-Regular;" type="text" @click="openzixun(system.id)">{{ system.name }}</el-button>
                    </div>
                    <div style="width: 100%">
                      <div class="white">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">体系编码：</span>
                        <template >
                          <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.code }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">发布时间：</span>
                        <template >
                          <span class="white" style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333">{{ system.createTime.substring(0,10) }}</span>
                        </template>
                      </div>
                      <div style="margin-top: 10px">
                        <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333"> 体系状态：</span>
                        <template >
                          <el-tag v-if="system.status=='1'" type="success">启用</el-tag>
                          <el-tag v-if="system.status=='0'" type="warning">停用</el-tag>
                        </template>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
<!--      标准-->
      <el-row style="margin-top: 10px" v-if="!showSystem">
        <el-col style="background-color: #FFFFFF">
          <div>
        <el-col style="margin-top: 20px;width: 360px;margin-left: 20px" >
          <div>
            <el-tag style="width: 100%;height: 40px;line-height: 40px">
              <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{ catalogTitle }}</span>
            </el-tag>
          </div>
        </el-col>
        <el-col  style="margin-left: 20px;margin-top:20px;width: 780px">
          <el-input style="width: 25%" v-model="Bz100StandardPageQuery.a100" placeholder="请输入标准号" clearable></el-input>
          <el-input style="width: 30%" v-model="Bz100StandardPageQuery.a298" placeholder="请输入标准中文名" clearable></el-input>
          <el-button style="height: 40px" type="primary" size="medium" @click="queryBz100StandardPageFun" icon="el-icon-search">查询</el-button>
          <el-button style="height: 40px" type="primary" size="medium" icon="el-icon-back" @click="showSystem=true,all=true">
            返回标准体系
          </el-button>
        </el-col>
          </div>
          <br>
          <div>
          <div >
        <el-col   style="font-size:14px;margin-top: 20px;width: 360px;margin-left: 20px"  v-if="!showSystem">
          <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
            <el-tree
              style="margin-left: -16px"
              id="standardTree" class="tree"
              :indent="0"
              ref="catalogTree" :data="dataList" :props="{label:'name'}" @node-click="showStandardSystemTable"
              :default-expand-all="true" :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node" >
            <span style="width: 100%">
              {{ node.label }}<template>
                        <span>({{ dianji1(data) }})</span>
                      </template>
            </span>
          </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
        <el-col  style="margin-left:20px;margin-top: 20px;width: 780px">
          <el-scrollbar style="height:calc(100vh - 300px);">
            <el-table v-loading="loading" :data="Bz100StandardPage.list" row-key="id" border stripe fit style="width: 100%;">
              <el-table-column label="标准号" prop="name" align="left">
                <template slot-scope="{row}">
                  <el-button type="text" @click="openDetailStd(row.id)">{{ row.a100 }}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="标准名称" prop="orgName" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.a298 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="标准类型" prop="standardType" width="110" align="left">
                <template slot-scope="{row}">
                  <div v-if="row.standardType!=null && row.standardType!=''">
                    <el-tag v-if="row.standardType==G" >国家标准</el-tag>
                    <el-tag v-if="row.standardType==C" >行业标准</el-tag>
                    <el-tag v-if="row.standardType==D" >地方标准</el-tag>
                    <el-tag v-if="row.standardType==T" >团体标准</el-tag>
                    <el-tag v-if="row.standardType==N" >国际国外标准</el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="发布时间" prop="code" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.a101 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实施时间" prop="sort" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.a205 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="页数" prop="abolishTime" width="50" align="left">
                <template slot-scope="{row}">
                  <span v-if="row.a305 == 0 || row.a305 == null">{{  }}</span>
                  <span v-else>{{ row.a305 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="105" align="left">
                <template slot-scope="{row}">
                  <!--                        <span>{{ row.a205 }}</span>-->
                  <!--                        icon="el-icon-download"-->
                  <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini" @click="readPDF(row.id)">全文阅读</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination :total="Bz100StandardPage.totalRow"
                        :page.sync="Bz100StandardPage.pageNumber"
                        :limit.sync="Bz100StandardPage.pageSize"
                        layout="total, prev, pager, next, jumper"
                        @pagination="queryBz100StandardPage"/>
          </el-scrollbar>
        </el-col>
          </div>
          </div>
        </el-col>
      </el-row>
<!--    政策  -->
      <el-row style="margin-top: 10px" v-if="!zhengce">
        <el-col style="background-color: #FFFFFF">
          <div style="display: flex">
          <el-col  style="margin-top:20px;width: 360px;margin-left: 20px" >
          <div>
            <el-tag style="width: 100%;height: 40px;line-height: 40px">
              <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{ catalogPolicyTitle }}</span>
            </el-tag>
          </div>
        </el-col>
            <div style="width: 780px">
          <el-col  style="margin-left: 20px;margin-top:20px">
          <el-input style="width: 25%" v-model="policyListPageQuery.title" placeholder="请输入标题" clearable></el-input>
          <el-input style="width: 30%" v-model="policyListPageQuery.documentNumber" placeholder="请输入文号" clearable></el-input>
          <el-button style="height: 40px" type="primary" size="medium" @click="queryPolicyPageFun" icon="el-icon-search">查询</el-button>
          <el-button style="height: 40px" type="primary" size="medium" icon="el-icon-back" @click="zhengce=true,all=true">
            返回政策体系
          </el-button>

        </el-col>
            </div>
          </div>
          <div style="width: 360px;margin-left: 20px;margin-top: 20px">
          <el-col   style="font-size:14px;min-height: 200px;" >
          <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
            <el-tree
              style="margin-left: -16px"
              id="policyTree" class="tree"
              :indent="0"
              ref="catalogTree" :data="zhengceList" :props="{label:'name'}" @node-click="showPolicySystemTable"
              :default-expand-all="true" :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node" >
            <span style="width: 100%">
              {{ node.label }}<template>
                        <span>({{ dianji1(data) }})</span>
                      </template>
            </span>
          </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
          </div>
          <el-col  style="width: 780px;margin-left:20px;">
          <el-scrollbar style="height:calc(100vh - 300px);">
            <el-table v-loading="loading" :data="policyListPage.list" row-key="id" border stripe fit style="width: 100%;">
              <el-table-column label="标题" prop="title" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <el-button type="text" @click="openzhengceStd(row.id)">{{row.title}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="文号" prop="documentNumber" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{ row.documentNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="timeIssue" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.timeIssue }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布单位" prop="issueUnit" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{ row.issueUnit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="主题分类" prop="subjectClassification" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{ row.subjectClassification }}</span>
                </template>
              </el-table-column>
<!--              <el-table-column label="时效状态" prop="agingState" align="left">-->
<!--                <template slot-scope="{row}">-->
<!--                  <dict type="aging_state" v-model="row.agingState"></dict>-->
<!--                </template>-->
<!--              </el-table-column>-->
            </el-table>
            <pagination :total="policyListPage.totalRow"
                        :page.sync="policyListPage.pageNumber"
                        :limit.sync="policyListPage.pageSize"
                        layout="total, prev, pager, next, jumper"
                        @pagination="queryPolicyPage"/>
          </el-scrollbar>
        </el-col>
        </el-col>
      </el-row>
<!--      机构-->
      <el-row style="margin-top: 10px" v-if="!jigou">
        <el-col  style="background-color: #FFFFFF">
          <div style="margin-top: 20px;display: flex">
          <el-col style="width: 360px;margin-left: 20px" >
          <div>
            <el-tag style="width: 100%;height: 40px;line-height: 40px">
              <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{ catalogOrgTitle }}</span>
            </el-tag>
          </div>
        </el-col>
          <el-col style="margin-left: 20px;width: 780px">
          <el-input style="width: 25%" v-model="orgListPageQuery.name" placeholder="请输入机构名称" clearable></el-input>
          <el-input style="width: 30%" v-model="orgListPageQuery.organizationCode" placeholder="请输入机构代码" clearable></el-input>
          <el-button style="height: 40px" type="primary" size="medium" @click="queryOrgPageFun" icon="el-icon-search">查询</el-button>
          <el-button style="height: 40px" type="primary" size="medium" icon="el-icon-back" @click="jigou=true,all=true">
            返回机构体系
          </el-button>
        </el-col>
          </div>
          <div style="width: 360px;margin-left: 20px;margin-top: 20px">
          <el-col   style="font-size:14px;min-height: 200px" >
          <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
            <el-tree
              style="margin-left: -16px"
              id="orgTree"
              class="tree"
              :indent="0"
              ref="catalogTree" :data="jigouList" :props="{label:'name'}" @node-click="showOrgSystemTable"
              :default-expand-all="true" :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node" >
            <span style="width: 100%">
              {{ node.label }}<template>
                        <span>({{ dianji1(data) }})</span>
                      </template>
            </span>
          </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
          </div>
          <el-col  style="width: 780px;margin-left:20px;">
          <el-scrollbar style="height:calc(100vh - 300px);">
            <el-table v-loading="loading" :data="orgListPage.list" row-key="id" border stripe fit style="width: 100%;">
              <el-table-column label="机构名称" prop="name" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <el-button type="text" @click="openjigouStd(row.id)">{{row.name}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="机构代码" prop="organizationCode" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{ row.organizationCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="关键字" prop="keyword" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.keyword }}</span>
                </template>
              </el-table-column>
              <el-table-column label="机构分类" prop="organizationClassification" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.organizationClassification }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination :total="orgListPage.totalRow"
                        :page.sync="orgListPage.pageNumber"
                        :limit.sync="orgListPage.pageSize"
                        layout="total, prev, pager, next, jumper"
                        @pagination="queryOrgPage"/>
          </el-scrollbar>
        </el-col>
        </el-col>
      </el-row>
<!--      资讯-->
      <el-row style="margin-top: 10px" v-if="!zixun">
        <el-col  style="background-color: #FFFFFF">
          <div style="margin-top: 20px;display: flex">
          <el-col  style="width: 360px;margin-left: 20px">
          <div>
            <el-tag style="width: 100%;height: 40px;line-height: 40px">
              <span style="font-family: SourceHanSansCN-Regular;font-size: 14px;color: #333333;margin-top: 5px">选择目录：</span><span>{{ catalogInfoTitle }}</span>
            </el-tag>
          </div>
        </el-col>
          <el-col  style="margin-left: 20px;width: 780px">
          <el-input style="width: 25%" v-model="infoListPageQuery.title" placeholder="请输入标题" clearable></el-input>
          <el-input style="width: 30%" v-model="infoListPageQuery.documentNumber" placeholder="请输入文号" clearable></el-input>
          <el-button style="height: 40px" type="primary" size="medium" @click="queryInfoPageFun" icon="el-icon-search">查询</el-button>
          <el-button style="height: 40px" type="primary" size="medium" icon="el-icon-back" @click="zixun=true,all=true">
            返回资讯体系
          </el-button>
        </el-col>
          </div>
          <el-col style="font-size:14px;min-height: 200px;margin-top: 20px;margin-left: 20px;width: 360px" >
          <el-scrollbar ref="treeDiv" class="tree-container" style="height:calc(100vh - 300px);">
            <el-tree
              style="margin-left: -16px"
              id="infoTree"
              class="tree"
              :indent="0"
              ref="catalogTree" :data="zixunList" :props="{label:'name'}" @node-click="showInfoSystemTable"
              :default-expand-all="true" :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node" >
            <span style="width: 100%">
              {{ node.label }}<template>
                        <span>({{ dianji1(data) }})</span>
                      </template>
            </span>
          </span>
            </el-tree>
          </el-scrollbar>
        </el-col>
          <el-col  style="width: 780px;margin-left:20px;margin-top: 20px">
          <el-scrollbar style="height:calc(100vh - 300px);">
            <el-table v-loading="loading" :data="infoListPage.list" row-key="id" border stripe fit style="width: 100%;">
              <el-table-column label="标题" prop="title" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <el-button type="text" @click="openzixunStd(row.id)">{{row.title}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="编号" prop="code" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column label="文号" prop="documentNumber" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.documentNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="timeIssue" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.timeIssue }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布单位" prop="issueUnit" align="left" :show-overflow-tooltip="true">
                <template slot-scope="{row}">
                  <span>{{ row.issueUnit }}</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination :total="infoListPage.totalRow"
                        :page.sync="infoListPage.pageNumber"
                        :limit.sync="infoListPage.pageSize"
                        layout="total, prev, pager, next, jumper"
                        @pagination="queryInfoPage"/>
          </el-scrollbar>
        </el-col>
        </el-col>
      </el-row>



      <description title="标准信息详情" :visible="showDetailStd" width="800px" @close="showDetailFun">
        <description-item label="标准号" v-model="detailStd.a100"></description-item>
        <description-item label="标准名称" v-model="detailStd.a298"></description-item>
        <description-item label="内部标准号" v-model="detailStd.standardNumber"></description-item>
        <description-item label="英文名字" v-model="detailStd.a302"></description-item>
        <description-item label="标准状态">
          <el-tag v-if="detailStd.a200=='1'" type="success">现行</el-tag>
          <el-tag v-if="detailStd.a200=='2'" type="warning">废止</el-tag>
        </description-item>
        <description-item label="标准类型">
          <div v-if="detailStd.standardType!=null && detailStd.standardType!=''">
            <el-tag v-if="detailStd.standardType==G" >国家标准</el-tag>
            <el-tag v-if="detailStd.standardType==C" >行业标准</el-tag>
            <el-tag v-if="detailStd.standardType==D" >地方标准</el-tag>
            <el-tag v-if="detailStd.standardType==T" >团体标准</el-tag>
            <el-tag v-if="detailStd.standardType==N" >国际国外标准</el-tag>
          </div>
        </description-item>
        <description-item label="发布日期" v-model="detailStd.a101"></description-item>
        <description-item label="实施日期" v-model="detailStd.a205"></description-item>
        <description-item label="废止日期" v-model="detailStd.a206"></description-item>
      </description>
      <description class="newsContent" title="政策信息详情" :visible="showzhengceStd" width="800px" @close="showzhengceFun">
<!--        <description-item label="政策号" v-model="detailStd.a100"></description-item>-->
<!--        <description-item label="政策名称" v-model="detailStd.a298"></description-item>-->
<!--        <description-item label="内部政策号" v-model="detailStd.standardNumber"></description-item>-->
<!--        <description-item label="英文名字" v-model="detailStd.a302"></description-item>-->
<!--        <description-item label="标准状态">-->
<!--          <el-tag v-if="detailStd.a200=='1'" type="success">现行</el-tag>-->
<!--          <el-tag v-if="detailStd.a200=='2'" type="warning">废止</el-tag>-->
<!--        </description-item>-->
<!--        <description-item label="发布日期" v-model="detailStd.a101"></description-item>-->
<!--        <description-item label="实施日期" v-model="detailStd.a205"></description-item>-->
<!--        <description-item label="废止日期" v-model="detailStd.a206"></description-item>-->
        <h1>{{policyDetail.title}}</h1>
        <p>发布单位：{{policyDetail.issueUnit}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发布时间：{{policyDetail.timeIssue}}</p>
        <div v-html="policyDetail.content"></div>
        <description-item label="附件">
          <div v-for="item in policyDetail.attachmentList" :key="item.filename"
               style="border-bottom: 1px #e6e6e6 solid; padding: 4px 0;display: flex;">
            <a :href="downloadUrl(item.filename)" style="color: #46a6ff;">
              <i class="el-icon-document" style="margin-right:5px;" />
              {{item.originName }}
            </a>
          </div>
        </description-item>
      </description>
      <description title="机构信息详情" :visible="showjigouStd" width="800px" @close="showjigouFun">
        <description-item label="机构名称" v-model="orgDetail.name"></description-item>
        <description-item label="机构代码" v-model="orgDetail.organizationCode"></description-item>
        <description-item label="关键字" v-model="orgDetail.keyword"></description-item>
        <description-item label="机构分类" v-model="orgDetail.organizationClassification"></description-item>
        <description-item label="工作范围" v-model="orgDetail.scopeWork"></description-item>
        <description-item label="业务指导单位" v-model="orgDetail.businessGuidanceUnit"></description-item>
        <description-item label="机构地址" v-model="orgDetail.institutionAddress"></description-item>
        <description-item label="秘书处所在单位" v-model="orgDetail.unitSecretariat"></description-item>
        <description-item label="机构联系人" v-model="orgDetail.institutionalContact"></description-item>
        <description-item label="联系人电话" v-model="orgDetail.contactNumber"></description-item>
        <description-item label="相关标准" v-model="orgDetail.relevantStandards"></description-item>
        <description-item label="更多标准信息" v-model="orgDetail.moreStandardInformation"></description-item>
        <description-item label="工作动态" v-model="orgDetail.workNews"></description-item>
      </description>
      <description class="newsContent" title="资讯信息详情" :visible="showzixunStd" width="800px" @close="showzixunFun">
        <h1>{{infoDetail.title}}</h1>
        <p>发布单位：{{infoDetail.issueUnit}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发布时间：{{infoDetail.timeIssue}}</p>
        <div v-html="infoDetail.content"></div>
      </description>
<!--        <el-dialog-->
<!--          title="pdf预览"-->
<!--          :visible.sync="showReadDialog"-->
<!--          :before-close="closeReadDialog"-->
<!--          width="900px"-->
<!--        >-->
<!--          <el-scrollbar style="height:calc(100vh - 300px);">-->
<!--            <div class="content">-->
<!--              <div>-->
<!--                <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>-->
<!--                <pdf-->
<!--                  ref="pdf"-->
<!--                  :src="pdgUrl"-->
<!--                  :page="pageNum"-->
<!--                  @progress="loadedRatio = $event"-->
<!--                  @num-pages="pageTotalNum=$event"-->
<!--                />-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-scrollbar>-->
<!--          <div slot="footer">-->
<!--            <el-button-group>-->
<!--              <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>-->
<!--              <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon&#45;&#45;right" />-->
<!--              </el-button>-->
<!--            </el-button-group>-->
<!--          </div>-->
<!--        </el-dialog>-->
        <el-dialog
          title="全文阅读"
          :visible.sync="showReadDialog"
          :before-close="closeReadDialog"
          class="pdfBox"
          fullscreen
          style="background-color: #666666;"
        >
          <el-scrollbar style=" height:100vh;background-color: #666;padding: 0px 0px!important;">
            <div class="content" style="background-color: #666666;width: 880px;margin: auto">
              <div>
                <!--              <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>-->
                <!--              <pdf-->
                <!--                ref="pdf"-->
                <!--                :src="pdgUrl"-->
                <!--                :page="pageNum"-->
                <!--                @progress="loadedRatio = $event"-->
                <!--                @num-pages="pageTotalNum=$event"-->
                <!--              />-->
                <pdf v-if="showReadDialog" style="margin: 5px"
                     ref="pdf"
                     v-for="i in numPages"
                     :key="i"
                     :src="pdgUrl"
                     :page="i"
                ></pdf>
              </div>
            </div>
          </el-scrollbar>
          <!--        <div slot="footer">-->
          <!--          <el-button-group>-->
          <!--            <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>-->
          <!--            <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon&#45;&#45;right" />-->
          <!--            </el-button>-->
          <!--          </el-button-group>-->
          <!--        </div>-->
        </el-dialog>
      </div>
      <loading v-show="pdfLoading"></loading>
    </div>
</template>
<script>
import request from "../../utils/request";
import description from "../../components/Description/description";
import descriptionItem from "../../components/Description/descriptionItem";
import { loading } from "../../components/Loading";
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import NavigationBar from "./compoment/navigationBar";
import Pagination from "../../components/page";
import pdf from 'vue-pdf'

export  default {
  name:'standardSystem',
  components: {Pagination, NavigationBar, description, descriptionItem,pdf,loading},
  data(){
    return {
      numPages: 0,
      showReadDialog: false,
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      pdgUrl: '',
      G:"G",
      C:"C",
      D:"D",
      T:"T",
      N:"N",
      biaozhuntixi:true,
      zhengcetixi:true,
      jigoutixi:true,
      zixuntixi:true,
      act: '1',
      all: true,
      showSystem:true,
      zhengce: true,
      jigou: true,
      zixun: true,
      input: "",
      imageUrlTop:require('../../../static/image/home.jpg'),
      systemName:getSystemName(),
      loading:true,
      pdfLoading: false,
      catalogTitle: '',
      belong:'',
      dataList: [],
      zhengceList: [],
      jigouList: [],
      zixunList: [],
      Bz100StandardPage:{
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      Bz100StandardPageQuery: {
        catalogId:'',
        pageNumber: 1,
        pageSize: 20,
        a100:'',
        a298:'',
        systemId:'',
        belong:getSystemId()
      },
      detailStd: {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber:'',
        standardType: ''
      },
      showDetailStd: false,
      showzhengceStd: false,
      showjigouStd: false,
      showzixunStd: false,
      pageQuerySystem: {
        pageNumber: 1,
        pageSize: 20,
        name: '',
        orgName: '',
        belong: '',
        status:'1'
      },
      //标准
      pageSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      //讯息
      infoSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      //政策
      policySystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      //机构
      orgSystem: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      policyListPageQuery: {
        pageNumber: 1,
        pageSize: 20,
        catalogId: '',
        title: '',
        documentNumber: '',
        systemId: ''
      },
      policyListPage: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      orgListPageQuery: {
        pageNumber: 1,
        pageSize: 20,
        catalogId: '',
        name: '',
        organizationCode: '',
        systemId: ''
      },
      orgListPage: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      infoListPageQuery: {
        pageNumber: 1,
        pageSize: 20,
        catalogId: '',
        title: '',
        documentNumber: '',
        systemId: ''
      },
      infoListPage: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      catalogPolicyTitle: '',
      catalogOrgTitle: '',
      catalogInfoTitle: '',
      orgDetail: {
        name: '',
        organizationCode: '',
        keyword: '',
        organizationClassification: '',
        scopeWork: '',
        businessGuidanceUnit: '',
        institutionAddress: '',
        unitSecretariat: '',
        institutionalContact: '',
        contactNumber: '',
        relevantStandards: '',
        moreStandardInformation: '',
        workNews: '',
        code: ''
      },
      policyDetail: {
        title: '',
        documentNumber: '',
        publisher: '',
        timeIssue: '',
        issueUnit: '',
        subjectClassification: '',
        effectivenessLevel: '',
        agingState: '',
        plainContent: '',
        content: '',
        annulmentRecords: '',
        keywords: '',
        attachments: '',
        attachmentList: [],
        code: ''
      },
      infoDetail: {
        title: '',
        keyword: '',
        documentNumber: '',
        issueUnit: '',
        timeIssue: '',
        plainContent: '',
        content: '',
        code: ''
      },
      isQueryStdType: false,
      isQueryInfoType: false,
      isQueryOrgType: false,
      isQueryPolicyType: false
    }
  },
  methods:{
    dianji1(data) {
      // console.log('data', data)
      let dat = data.count != null ? data.count : 0

      if (data.children && data.children.length > 0) {
        dat += this.traversalObject(data.children, dat)
      }
      // console.log('datdatdatdat', dat)
      return dat
    },

    traversalObject(obj, dat) {
      let dataCount = 0
      const _this = this
      obj.forEach(function(item) {
        dataCount = dataCount + item.count
        if (item.children && item.children.length > 0) {
          dataCount += _this.traversalObject(item.children, dat)
        }
      })
      return dataCount
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdgUrl)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    localUrl0(fileName) {
      const _this = this
      request({
        url: '/attachmentByFile',
        method: 'get',
        params: {
          name: fileName
        },
        responseType: 'blob'
      }).then(rsp => {
        this.pdfLoading = false
        let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    localUrl(fileName) {
      const _this = this
      request({
        url: '/attachmentByDir',
        method: 'get',
        params: {
          name: fileName,
          type: 'projectDocAndPdf'
        },
        responseType: 'blob'
      }).then(rsp => {
        this.pdfLoading = false
        let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    closeReadDialog() {
      // URL.revokeObjectURL(this.pdgUrl)
      this.showReadDialog = false
      this.pageNum = 1
      this.pageTotalNum = 1
      this.loadedRatio = 0
      window.URL.revokeObjectURL(this.pdgUrl)
      this.pdgUrl = ''
    },
    readPDF(id) {
      if (!row.fileAddress) {
        let stdNo = row.a100.replace('—', '-')
        window.open('https://openstd.samr.gov.cn/bzgk/std/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=' + encodeURIComponent(stdNo), '_blank')
        return
      }
      const _this = this
      this.pdfLoading = true
      request({
        url: '/portalController/getStandardFileById',
        method: 'get',
        params: {
          id: id,
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          _this.standard = rsp.data
          if (_this.standard != null) {
            if (!_this.standard.dowPrivileges || _this.standard.dowPrivileges == null || _this.standard.dowPrivileges == 0) {
              this.pdfLoading = false
              _this.$message.error('暂无权限')
            }
            if (_this.standard.dowPrivileges && _this.standard.dowPrivileges != null && _this.standard.dowPrivileges != 0) {
              if(_this.standard.fileAddress && _this.standard.fileAddress != null && _this.standard.fileAddress != '') {
                if (_this.standard.types != '0') {
                  // _this.pdgUrl = config.VUE_APP_BASE_API + `/attachmentByDir?name=${_this.standard.fileAddress}&type=projectDocAndPdf`
                  // _this.showReadDialog = true
                  _this.localUrl(_this.standard.fileAddress)
                } else {
                  _this.localUrl0(_this.standard.fileAddress)
                  // _this.pdgUrl = config.VUE_APP_BASE_API + `/attachmentByFile?name=${_this.standard.fileAddress}`
                  // _this.showReadDialog = true
                }

              } else {
                this.pdfLoading = false
                _this.$message.error('暂无文件')
              }

            }
            // this.showBz100StandardDetail = true
          } else {
            this.pdfLoading = false
            _this.$message.error('暂无权限')
            // this.showStandardDetail = true
          }
        } else {
          this.pdfLoading = false
        }
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadUrl(filename) {
      return `${process.env.VUE_APP_BASE_API}/attachmentByDir?name=${filename}&type=policiesRegulations`
    },
    showOrgSystemTable(data,node) {
      this.orgListPageQuery.name=''
      this.orgListPageQuery.organizationCode=''
      this.orgListPageQuery.pageNumber = 1
      this.catalogOrgTitle = data.name
      // if(node.level===1){
      //   this.orgListPageQuery.catalogId=''
      // }else {
        this.orgListPageQuery.catalogId = data.id
      // }
      this.isQueryOrgType = false
      this.queryOrgPage()
    },
    showInfoSystemTable(data,node) {
      this.infoListPageQuery.title=''
      this.infoListPageQuery.documentNumber=''
      this.infoListPageQuery.pageNumber = 1
      this.catalogInfoTitle = data.name
      // if(node.level===1){
      //   this.infoListPageQuery.catalogId=''
      // }else {
        this.infoListPageQuery.catalogId = data.id
      // }
      this.isQueryInfoType = false
      this.queryInfoPage()
    },
    showPolicySystemTable(data,node) {
      // console.log('datadatadatadata', data)
      this.policyListPageQuery.title=''
      this.policyListPageQuery.documentNumber=''
      this.policyListPageQuery.pageNumber = 1
      this.catalogPolicyTitle = data.name
      // if(node.level===1){
      //   this.policyListPageQuery.catalogId = ''
      // }else {
        this.policyListPageQuery.catalogId = data.id
      // }
      this.isQueryPolicyType = false
      this.queryPolicyPage()
    },
    queryOrgPageFun() {
      this.isQueryOrgType = true
      this.orgListPageQuery.pageNumber = 1
      this.queryOrgPage()
    },
    async queryOrgPage(data) {
      this.loading = true
      // this.Bz100StandardPageQuery.catalogId = data.id
      if (data) {
        this.orgListPageQuery.pageNumber = data.page
        this.orgListPageQuery.pageSize = data.limit
      }
      if (this.orgListPageQuery.catalogId != '') {
        await request.post('/portalController/getSearchOrgList', this.orgListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.orgListPage = rsp.data
          } else {
            console.log(rsp)
            // this.$message.error('操作失败')
          }
          this.loading = false
        })
      } else {
        await request.post('/portalController/queryOrgBySystemId', this.orgListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.orgListPage = rsp.data
          } else {
            console.log(rsp)
            // this.$message.error('操作失败')
          }
          this.loading = false
        })
      }
      // await request.post('/portalController/queryOrgBySystemId', this.orgListPageQuery).then(rsp => {
      //   if (rsp.resultCode === '0') {
      //     this.orgListPage = rsp.data
      //   } else {
      //     console.log(rsp)
      //     // this.$message.error('操作失败')
      //   }
      //   this.loading = false
      // })
    },
    queryPolicyPageFun() {
      this.isQueryPolicyType = true
      this.policyListPageQuery.pageNumber = 1
      this.queryPolicyPage()
    },
    async queryPolicyPage(data) {
      this.loading = true
      // this.Bz100StandardPageQuery.catalogId = data.id
      if (data) {
        this.policyListPageQuery.pageNumber = data.page
        this.policyListPageQuery.pageSize = data.limit
      }
      if (this.policyListPageQuery.catalogId != '') {
        await  request.post('/portalController/getSearchPolicyList', this.policyListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.policyListPage = rsp.data
          } else {
            console.log(rsp)
          }
          this.loading = false
        })
      } else {
        await  request.post('/portalController/queryPolicyBySystemId', this.policyListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.policyListPage = rsp.data
          } else {
            console.log(rsp)
          }
          this.loading = false
        })
      }
     // await  request.post('/portalController/queryPolicyBySystemId', this.policyListPageQuery).then(rsp => {
     //    if (rsp.resultCode === '0') {
     //      this.policyListPage = rsp.data
     //    } else {
     //      console.log(rsp)
     //    }
     //    this.loading = false
     //  })
    },
    queryInfoPageFun() {
      this.isQueryInfoType = true
      this.infoListPageQuery.pageNumber = 1
      this.queryInfoPage()
    },
    async queryInfoPage(data) {
      this.loading = true
      // this.Bz100StandardPageQuery.catalogId = data.id
      if (data) {
        this.infoListPageQuery.pageNumber = data.page
        this.infoListPageQuery.pageSize = data.limit
      }
      if (this.infoListPageQuery.catalogId != '') {
        await request.post('/portalController/getSearchInfoList', this.infoListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.infoListPage = rsp.data
          } else {
            console.log(rsp)
            // this.$message.error('操作失败')
          }
          this.loading = false
        })
      } else {
        await request.post('/portalController/queryInfoBySystemId', this.infoListPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.infoListPage = rsp.data
          } else {
            console.log(rsp)
            // this.$message.error('操作失败')
          }
          this.loading = false
        })
      }
      // await request.post('/portalController/queryInfoBySystemId', this.infoListPageQuery).then(rsp => {
      //   if (rsp.resultCode === '0') {
      //     this.infoListPage = rsp.data
      //   } else {
      //     console.log(rsp)
      //     // this.$message.error('操作失败')
      //   }
      //   this.loading = false
      // })
    },
    //标准
    async openDetail(id){
      this.all=false
      this.showSystem=false
      await this.queryCatalogList(id);
      this.Bz100StandardPageQuery.systemId=id
      this.isQueryStdType = false
      await this.queryBz100StandardPage();
    },
    //政策
    async openzhengce(id){
      this.all=false
      this.zhengce=false
      await this.queryzhengceList(id);
      this.policyListPageQuery.systemId=id
      // zhengceList
      this.isQueryPolicyType = false
      await this.queryPolicyPage();
    },
    //机构
    async openjigou(id){
      this.all=false
      this.jigou=false
      await this.queryjigouList(id);
      this.orgListPageQuery.systemId=id
      this.isQueryOrgType = false
      await this.queryOrgPage();
    },
    //资讯
    async openzixun(id){
      this.all=false
      this.zixun=false
      await this.queryzixunList(id);
      this.infoListPageQuery.systemId=id
      this.isQueryInfoType = false
      await this.queryInfoPage();
    },
    /**
     * 跳转标准查询页
     */
    toSearch() {
      this.$router.push({ path: "/standard", query: { input: this.input } });
    },
    /**
     * 获取标准目录
     */
    async queryCatalogList(id) {
      this.loading = true
      await request({
        url: '/portalController/list',
        methods: 'get',
        params: {
          systemId: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.dataList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    //获取政策目录
    async queryzhengceList(id) {
      this.loading = true
      await request({
        url: '/portalController/policyList',
        methods: 'get',
        params: {
          systemId: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.zhengceList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    //获取机构目录
    async queryjigouList(id) {
      this.loading = true
      await request({
        url: '/portalController/orgList',
        methods: 'get',
        params: {
          systemId: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.jigouList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    //获取资讯目录
    async queryzixunList(id) {
      this.loading = true
      await request({
        url: '/portalController/infoList',
        methods: 'get',
        params: {
          systemId: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.zixunList = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    /**
     * 解析路径参数
     */
    splitPath(path){
      let args = path.split("?");
      const param = args[1]
      let params = param.split('&')
      this.pathValue = params[0].split('=')[1];
      const tempType = params[1].split('=')[1];
      switch (tempType) {
        case 'biaozhun':
          this.act = '1'
          break
        case 'zhengce':
          this.act = '2'
          break
        case 'jigou':
          this.act = '3'
          break
        case 'zixun':
          this.act = '4'
          break
      }
      this.Bz100StandardPageQuery.catalogId=this.pathValue
      this.queryBz100StandardPage();
    },
    queryBz100StandardPageFun() {
      this.isQueryStdType = true
      this.Bz100StandardPageQuery.pageNumber = 1
      this.queryBz100StandardPage()
    },
    /**
     * 查询标准分页
     */
    async queryBz100StandardPage(data) {
      this.loading = true
      if (data) {
        this.Bz100StandardPageQuery.pageNumber = data.page
        this.Bz100StandardPageQuery.pageSize = data.limit
      }
      if (this.Bz100StandardPageQuery.catalogId != '') {
        await request.post('/portalController/getSearchStdList', this.Bz100StandardPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.Bz100StandardPage = rsp.data
          } else {
            this.$message.error('操作失败')
          }
        })
      } else {
        await request.post('/portalController/queryStandardBySystemId', this.Bz100StandardPageQuery).then(rsp => {
          if (rsp.resultCode === '0') {
            this.Bz100StandardPage = rsp.data
          } else {
            this.$message.error('操作失败')
          }
        })
      }
      // await request.post('/portalController/queryStandardBySystemId', this.Bz100StandardPageQuery).then(rsp => {
      //   if (rsp.resultCode === '0') {
      //     this.Bz100StandardPage = rsp.data
      //   } else {
      //     this.$message.error('操作失败')
      //   }
      // })
      this.loading = false
    },
    //
    /**
     * 标准查看详情
     * @param id
     */
    openDetailStd(id) {
      request({
        url: '/portalController/getBz100Standard',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {

        if (rsp.resultCode === '0') {
          this.detailStd = rsp.data
          console.log(this.detailStd)
          this.showDetailStd = true
        }
      })
    },
    // 政策查看详情
    openzhengceStd(id) {
      request({
        url: '/portalController/getPoliciesById',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {

        if (rsp.resultCode === '0') {
          this.policyDetail = rsp.data
          this.showzhengceStd = true
        }
      })
    },
    //机构查看详情
    openjigouStd(id) {
      request({
        url: '/portalController/getOrgById',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {

        if (rsp.resultCode === '0') {
          this.orgDetail = rsp.data
          this.showjigouStd = true
        }
      })
    },
    //资讯查看详情
    openzixunStd(id) {
      request({
        url: '/portalController/getNewsById',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {

        if (rsp.resultCode === '0') {
          this.infoDetail = rsp.data
          this.showzixunStd = true
        }
      })
    },
    /**
     * 关闭查看标准详情
     */
    showDetailFun() {
      this.showDetailStd = false
      this.detailStd = {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: '',
        standardType: ''
      }
    },
    //关闭查看政策详情
    showzhengceFun() {
      this.showzhengceStd = false
      this.detailStd = {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: '',
      }
    },
    //关闭查看机构详情
    showjigouFun() {
      this.showjigouStd = false
      this.detailStd = {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: ''
      }
    },
    //关闭查看资讯详情
    showzixunFun() {
      this.showzixunStd = false
      this.detailStd = {
        a100: '',
        a101: '',
        a205: '',
        a206: '',
        a298: '',
        a302: '',
        a200: '',
        standardNumber: ''
      }
    },
    showStandardSystemTable(data,node) {
      this.Bz100StandardPageQuery.a100=''
      this.Bz100StandardPageQuery.a298=''
      this.Bz100StandardPageQuery.pageNumber=1
      this.catalogTitle = data.name
      // console.log('data', data)
      // if(node.level===1){
      //   this.Bz100StandardPageQuery.catalogId=''
      // }else {
        this.Bz100StandardPageQuery.catalogId = data.id
      // }
      this.isQueryStdType = false
      this.queryBz100StandardPage()
    },
    /**
     * 标准体系列表
     */
    getSystemList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/querySystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.pageSystem = rsp.data
          this.biaozhuntixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    /**
     * 政策体系列表
     */
    getpolicyList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryPolicySystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.policySystem = rsp.data
          this.zhengcetixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    /**
     * 机构体系列表
     */
    getorgList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryOrgSystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.orgSystem = rsp.data
          this.jigoutixi = false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
    /**
     * 资讯体系列表
     */
    getinfoList(data){
      if (data) {
        this.pageQuerySystem.pageNumber = data.page
        this.pageQuerySystem.pageSize = data.limit
      }
      this.pageQuerySystem.belong=this.belong
      request.post('/portalController/queryInfoSystemList', this.pageQuerySystem).then(rsp => {
        if (rsp.resultCode === '0') {
          this.infoSystem = rsp.data
          this.zixuntixi =false
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
      })
    },
  },
  created() {
    this.belong = getSystemId()
  },
  mounted() {
    document.title = this.systemName
    if(window.location.href.split("?")[1]!=''&&window.location.href.split("?")[1]!=null){
      this.splitPath(window.location.href)
    }
    this.getSystemList();
    this.getinfoList();
    this.getorgList();
    this.getpolicyList();
  },
}
</script>
<style scoped>
.right {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABtUlEQVRYhcXWz0vCYBgH8O/UpEDSOoSXAvUQBHULQggCCapLtzpE525douhSWpf6A+pUEESXDhIU0bVTUFF0EekHClFCMQUNNXVlLDLcnL7v3LvtuWx7373v++HZu2fjHLeBEIAgTAoLABGwZiYAZiIsVeemICyya8MRcoDhCKt9zqvUfg6AAzDCaqGBNh9u+vZQLJdwlY3+tytloBLMMtFt70LYtwGn1YHMV07S1wgAtYgDTxBL7hlJm7jokW8T7pZO7PDH2E+eSfptFPOG/o7EYuV39GPSNYyUkMEufwI7Z8Ohdx29rT04TV9g8WWrZky9PSAPqj1xmY1gqiOACZcfd/lHLLtnMeYcwnU2iunYCoploWaMWIppAJUglm0xA/ue1V8tBw6xwisCD/PghbTi/bQZqAQxE/efz/j4zmG0fRBJIY3xpwUkSnzdCWn2gDyIe2L7PYy3UgqRfBzxQqLhZGofQXUw+YqSXkMSQHOd0AJggtAK0IxgAdCEYAVoGsES0BSCNUA1Qg+AKoReAGqEngAqhN4AIsIIQEOEUYC6CCMBigijATUIMwASRDN/ROwQAH4AFix1WZqCV78AAAAASUVORK5CYII=");
  background-position: 100% 0%;
  background-size: 16px;
  background-repeat: no-repeat;
}
.wrong {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABkUlEQVRYhcXVv44BQRwH8O+M3YSCREQiGoXCn0ql0YhaiVKl8gbI5dwzKHVEgWIjask9gJB4AA+gpHG5tXPhmmVZszv751ftzM5MPrvfzW/JTzLZB/AJn4oCuAK+/ATATwTVXfuCoA9jzxGPAM8RzwC2EbRahbzdgpZK9zdiMciKAmkw4AbYQrD9HiQUgjQagVYqtzkSj0OezUCKRbDdzrDn2gfenWupT5B8HvJ0CkQiUHs9BNptkFQKl34fl+HQFsA6IpuFNJmAJBKApkHtdqGNx0/XmkXwCOCPgzHzsa4CH+Ew77Hf14cDUDZbRHI5yPM5SDQKtdMByWQQqNWA4xFssxECvEXc8lcUIBiE2mpBWyzAlkvQchm0XgdOJwOCNwJ9vYyDpNNg5zPUZhPaanWbY4cDfhsNsPUapFAw7uH8CF9BhP+idt6AHiDcMUUAjiBEAcIIJwBCCKcAthFOAmwhnAZYRrgBsIRwC8CNcBPAhXAb8BbhBcAU4RXgJcJLwFOE1wADwg/AHULyCfCPAPAHqPFvXhI80B0AAAAASUVORK5CYII=");
  background-position: 100% 0%;
  background-size: 16px;
  background-repeat: no-repeat;
}
</style>
<style >
.pdfBox {
  padding: 0 0!important;
}
.pdfBox .el-dialog__body {
  padding: 0px 0px;
  background-color: #666666!important;
}
.el-tree-node__content {
  font-size: 14px !important;
}
.el-tabs__item.is-left{
  width: 150px;
  height: 55px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  text-align: center !important;
  line-height: 55px;
}
.page1 .el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

.el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

/*//有子节点 且未展开*/
.el-tree .el-icon-caret-right:before {
  background: url('../../../src/assets/image/folder.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//有子节点 且已展开*/
.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url('../../../src/assets/image/open.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}

/*//没有子节点*/
.el-tree .el-tree-node__expand-icon.is-leaf::before {
  background: url('../../../src/assets/image/file.png') no-repeat 0 1px;
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 16px;
}
.el-tabs__active-bar.is-left{
  width: 0px !important;
}
</style>
<style scoped>
.newsContent h1, .newsContent p {
  text-align: center;
}

.newsContent p {
  color: #666;
}

.newsContent div {
  padding: 20px 10px;
}
  .tree /deep/ .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  .tree /deep/ .el-tree-node__children {
    padding-left: 16px;
  }

  .tree /deep/ .el-tree-node :last-child:before {
    height: 38px;
  }

  .tree /deep/ .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .tree-container /deep/ .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .tree /deep/ .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .tree /deep/ .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .tree /deep/ .el-tree-node:before {
    border-left: 1px solid #d1d2d3;
    bottom: 0px;
    height: 100%;
    top: -26px;
    width: 1px;
  }

  .tree /deep/ .el-tree-node:after {
    border-top: 1px solid #d1d2d3;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  .tree-container {
  }
  .page1{
    background: url("../../../static/image/body-bg.jpg") no-repeat;
    height: 100%;
    width: 100%;
    background-size:100% 775px;
  }
  >>> .el-tabs__nav .el-tabs__item:hover {
    color: #ffffff;
    background-color: #004e96 ;
  }
  >>> .el-tabs__nav .el-tabs__item.is-active {
    color: #ffffff;
    background-color: #004e96;
  }
  >>> .el-tabs__nav .el-tabs__item {
    color: #000000;
    background-color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/standardSystem.vue